import React from 'react';
import Hero from '../components/Hero';
import {Link} from 'react-router-dom';
const CartPage = () => {
    return (
        <div>
            cart page
        </div>
    );
};

export default CartPage;